// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1393c316","453":"cf1752c9","498":"35a5f76c","551":"287f1c14","572":"61e9a776","616":"c7954cd3","842":"ba285d65","851":"2fc5b0d6"}[chunkId] + ".chunk.js";
};